import { CircleX } from 'lucide-react';
import { Button, EmptyState, Logo, Spinner } from '@elbklar/ui';

import { useAuth } from './AuthContext';

/**
 * Landepunkt nach dem Google-OAuth.
 *
 * Der Auth-Service hat das Cookie bereits gesetzt; der AuthContext liest die
 * Sitzung beim Mounten. Diese Seite zeigt nur den Zwischenzustand — und leitet
 * weiter, sobald die Anmeldung steht.
 */
export function AuthCallbackPage() {
  const { error, isAuthenticated, isLoading } = useAuth();

  if (!isLoading && isAuthenticated) {
    window.location.replace('/');
    return null;
  }

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-8 bg-background p-6">
      <Logo variant="horizontal" height={40} />
      {error ? (
        <EmptyState
          icon={CircleX}
          title="Anmeldung fehlgeschlagen"
          description={error}
          action={
            <Button asChild variant="primary" size="lg">
              <a href="/login">Zurück zur Anmeldung</a>
            </Button>
          }
        />
      ) : (
        <div className="flex flex-col items-center gap-4 text-center">
          <Spinner size={32} />
          <p className="text-muted-foreground">Anmeldung läuft</p>
        </div>
      )}
    </div>
  );
}
